import { render, staticRenderFns } from "./RadioCudeBoxSwArea.vue?vue&type=template&id=1f5ff0fe&"
import script from "./RadioCudeBoxSwArea.vue?vue&type=script&lang=js&"
export * from "./RadioCudeBoxSwArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports